'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Logger implementation utilizing console, if available
 */

// Just to break this down for future devs:
//   If we're not in DEV mode, return empty object
//   else check for a global "console" and use that
//   else check window exists and window.console, if so, use that
var baseConsole = __DEV__ && (console || window && window.console) || {};

var fakeConsole = {
  assert: function assert() {},
  count: function count() {},
  dir: function dir() {},
  error: function error() {},
  info: function info() {},
  profile: function profile() {},
  profileEnd: function profileEnd() {},
  table: function table() {},
  time: function time() {},
  timeEnd: function timeEnd() {},
  timeStamp: function timeStamp() {},
  warn: function warn() {}
};

var innerConsole = (0, _assign2.default)({}, fakeConsole, baseConsole);

/**
 * Logger implements a wrapper around the console logging facilities to ensure
 * these logs don't come out in production, and provide hooks to other monitoring
 * systems.
 *
 * Takes an optional prefix list, which can contain functions or other objects.
 * If a function, it will be called iwth the messages that are getting logged
 */

var Logger = exports.Logger = function () {
  function Logger() {
    var prefixes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    (0, _classCallCheck3.default)(this, Logger);

    this.prefixes = prefixes;
  }

  (0, _createClass3.default)(Logger, [{
    key: '_fmtMsgs',
    value: function _fmtMsgs(msgs) {
      if (this.prefixes.length === 0) return msgs;

      var outputPrefixes = this.prefixes.map(function (prefix) {
        return typeof prefix === 'function' ? prefix(msgs) : prefix;
      });

      // If the first msg is a string, we can't just put a prefix
      // before it as it will clobber the string formatting
      // functionality, so we just prepend the prefixes with a space
      if (typeof msgs[0] === 'string') {
        msgs[0] = outputPrefixes.join(' ') + ' ' + msgs[0];
        return msgs;
      }

      return outputPrefixes.concat(msgs);
    }

    /**
     * Info log
     * @param msgs - the messages to log - uses same format as console method
     */

  }, {
    key: 'info',
    value: function info() {
      for (var _len = arguments.length, msgs = Array(_len), _key = 0; _key < _len; _key++) {
        msgs[_key] = arguments[_key];
      }

      innerConsole.info.apply(innerConsole, (0, _toConsumableArray3.default)(this._fmtMsgs(msgs)));
    }

    /**
     * Warning log
     * @param msgs - the messages to log - uses same format as console method
     */

  }, {
    key: 'warn',
    value: function warn() {
      for (var _len2 = arguments.length, msgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msgs[_key2] = arguments[_key2];
      }

      innerConsole.warn.apply(innerConsole, (0, _toConsumableArray3.default)(this._fmtMsgs(msgs)));
    }

    /**
     * Error log
     * @param msgs - the messages to log - uses same format as console method
     */

  }, {
    key: 'error',
    value: function error() {
      for (var _len3 = arguments.length, msgs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msgs[_key3] = arguments[_key3];
      }

      // TODO: NewRelic Integration
      innerConsole.error.apply(innerConsole, (0, _toConsumableArray3.default)(this._fmtMsgs(msgs)));
    }

    /**
     * Exception log - Internally uses error log, but takes an exception which will
     * be printed at the end
     * @param ex - Exception to log
     * @param msgs - the messages to log - uses same format as console error method
     */

  }, {
    key: 'exception',
    value: function exception(ex) {
      for (var _len4 = arguments.length, msgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        msgs[_key4 - 1] = arguments[_key4];
      }

      // TODO: NewRelic Integration
      innerConsole.error.apply(innerConsole, (0, _toConsumableArray3.default)(this._fmtMsgs(msgs)).concat(['\n', ex]));
    }

    /**
     * Table log
     * @param data - the data to log in the table
     * @param columns - the columns to log for the table
     */

  }, {
    key: 'table',
    value: function table(data, columns) {
      innerConsole.table(data, columns);
    }

    /**
     * Dir log - logs an object output
     * @param obj - the object to log
     */

  }, {
    key: 'dir',
    value: function dir(obj) {
      innerConsole.dir(obj);
    }

    /**
     * Assertion
     * @param assertion - if false, assertion failed
     * @param msgs - the messages to log on assertion failure - uses same format as console method
     */

  }, {
    key: 'assert',
    value: function assert(assertion) {
      for (var _len5 = arguments.length, msgs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        msgs[_key5 - 1] = arguments[_key5];
      }

      // TODO: NewRelic Integration? I think failed assertions should probably be logged in NewRelic
      innerConsole.assert.apply(innerConsole, [assertion].concat((0, _toConsumableArray3.default)(this._fmtMsgs(msgs))));
    }

    /**
     * Count log
     * @param label - the label to count
     */

  }, {
    key: 'count',
    value: function count(label) {
      innerConsole.count(label);
    }

    /**
     * Time log
     * @param label - the label to use for the timing
     */

  }, {
    key: 'time',
    value: function time(label) {
      innerConsole.time(label);
    }

    /**
     * TimeEnd log
     * @param label - the label of the time to stop timing
     */

  }, {
    key: 'timeEnd',
    value: function timeEnd(label) {
      innerConsole.timeEnd(label);
    }

    /**
     * Timestamp log
     * @param label - the label to use for the timestamp
     */

  }, {
    key: 'timeStamp',
    value: function timeStamp(label) {
      innerConsole.timeStamp(label);
    }

    /**
     * Profile log
     * @param name - the name of the profile to output
     */

  }, {
    key: 'profile',
    value: function profile(name) {
      innerConsole.profile(name);
    }

    /**
     * ProfileEnd log
     * @param name - end the profile of the given name
     */

  }, {
    key: 'profileEnd',
    value: function profileEnd(name) {
      innerConsole.profileEnd(name);
    }
  }]);
  return Logger;
}();

/**
 * Default logger which is used by default when logging
 * @type {Logger}
 */


var defaultLogger = new Logger();

// Export wrapped defaultLogger so no bad engineer mutates it
exports.default = {
  assert: defaultLogger.assert.bind(defaultLogger),
  count: defaultLogger.count.bind(defaultLogger),
  dir: defaultLogger.dir.bind(defaultLogger),
  error: defaultLogger.error.bind(defaultLogger),
  exception: defaultLogger.exception.bind(defaultLogger),
  info: defaultLogger.info.bind(defaultLogger),
  profile: defaultLogger.profile.bind(defaultLogger),
  profileEnd: defaultLogger.profileEnd.bind(defaultLogger),
  table: defaultLogger.table.bind(defaultLogger),
  time: defaultLogger.time.bind(defaultLogger),
  timeEnd: defaultLogger.timeEnd.bind(defaultLogger),
  timeStamp: defaultLogger.timeStamp.bind(defaultLogger),
  warn: defaultLogger.warn.bind(defaultLogger)
};
//# sourceMappingURL=index.js.map